module.exports = __webpack_public_path__ + "static/kobe-3-a5beb34481af6884b23704aefb49cbd5.jpg";